export var CLEAR_INITIALIZATION = "@@firekit/INITIALIZATION@CLEAR_INITIALIZATION";


//////////////////
// WEBPACK FOOTER
// ./node_modules/firekit/es/store/initialization/types.js
// module id = 297
// module chunks = 49